import { commonUrl, postRequest, ResponseDI, } from "../../../base/services/urlService";
import { LessonDI } from "../types";

interface UpdateLessonResponseResultDI { }

export const editLesson = async (lesson: LessonDI) => {
  const response = await postRequest<LessonDI, ResponseDI<UpdateLessonResponseResultDI>>(`${commonUrl}/api/lesson/UpdateLesson`, lesson);
  return response.result;
};
